import { __ } from '@wordpress/i18n';
import UpgradeButton from '../../vayu-sites/template/UpgradeButton';

const BlocksIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
);

const SettingsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
);

const TemplatesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
);

function Header({ activeTab, handleTabClick, link = vayublock.homeUrl, template = true }) {
    const version = vayublock.version || '';
  const params = new URLSearchParams(window.location.search);
  const pageTemplate = params.get("template");
const headerStyle = pageTemplate ? { top: "0", position: "sticky" } : {};
    return (
        <div className="th-header"   style={headerStyle} >
            <div className="th-conatiner">
                <div className="th-header-wrap">
                    <div className="th-logo-wrap">
                        <a href={`${window.location.pathname}?page=vayu-blocks`}>
                            <img src={`${link}assets/img/logo-vayu.png`} alt="Vayu Blocks" />
                            <h2>{__('Vayu Blocks', 'vayu-blocks')}</h2>
                            {version && <span className="th-version-badge">v{version}</span>}
                        </a>
                    </div>
                    <div className="th-menu-wrap">
                        {template && (<>
                            <div className={`th-menu-item ${activeTab === 'welcome' ? 'active' : ''}`} onClick={() => handleTabClick('welcome')}>
                                <BlocksIcon />
                                {__('Blocks', 'vayu-blocks')}
                            </div>
                            <div className={`th-menu-item ${activeTab === 'blocks' ? 'active' : ''}`} onClick={() => handleTabClick('blocks')}>
                                <SettingsIcon />
                                {__('Settings', 'vayu-blocks')}
                            </div>
                        </>)}
                        <div className={`th-menu-item ${activeTab === 'sites' ? 'active' : ''}`} onClick={() => handleTabClick('sites')}>
                            <TemplatesIcon />
                            {__('Starter Templates', 'vayu-blocks')}
                        </div>
                    </div>
                    <div className='header-text'>
                        <UpgradeButton />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;
